interface Assignment {
  assignment_classrooms: Classroom[];
}

interface Classroom {
  id: number;
  classroom_id: number;
}

const getRelevantWritePromptClassrooms = (
  classrooms: Classroom[],
  assignment: Assignment | undefined,
): Classroom[] => {
  if (!assignment) {
    return classrooms;
  }

  // Use assignment classrooms as the classroom list if applicable
  if (assignment?.assignment_classrooms?.length) {
    const assignmentClassroomIds = assignment?.assignment_classrooms?.map(
      (classroom) => classroom?.classroom_id,
    );
    classrooms = classrooms?.filter((classroom) => {
      return assignmentClassroomIds?.includes(classroom?.id);
    });
  }

  return classrooms;
};

export default getRelevantWritePromptClassrooms;
